import React, {Component} from "react"

import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import Form from "@irati/ui/src/Form"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {CompanyNewsTile, CompanyNewsTileConfig, CompanyNewsTileType} from "@irati/types"
import {updateCompanyNewsTile} from "@irati/culture-hub/services/homepage"
import tracking from "@irati-tracking/homepage"

import ContentFooter from "./Footer"
import NewImage from "./NewImage"
import NewTemplateTile from "./NewTemplateTile"
import NewVideo from "./NewVideo"
import Preview from "./Preview"
import {ModalContent} from "../../Modal/styled"
import {SelectedTab} from "./types"

interface Props extends InjectIntl, WithAuth {
  companyNewsTile: CompanyNewsTile,
  currentTab: SelectedTab,
  isPreview: boolean,
  onClose: () => void,
  setPreview: (val: boolean) => void
}

interface State {
  imageError?: string,
  load?: boolean,
  updatedContent: CompanyNewsTileConfig
}

class CompanyNewsContentForm extends Component<Props, State> {
  state: State = {
    updatedContent: this.props.companyNewsTile.config
  }

  updateTile = (tileConfig: CompanyNewsTileConfig, tile: CompanyNewsTile, onClose: () => void) => {
    const {currentTab, auth} = this.props
    const variables = {
      tenantId: auth.business.uuid,
      tile: {
        config: tileConfig,
        xpos: tile.xpos,
        ypos: tile.ypos
      }
    }

    this.setState({load: true})
    updateCompanyNewsTile(variables).then(() => {
      this.setState({load: false})
      tracking.homePageAddNewTileSubmit(currentTab)
      onClose()
    })
  }

  validateHasImage = (newContentObject: CompanyNewsTileConfig): boolean => {
    if (newContentObject.type === CompanyNewsTileType.Video) {
      return true
    }

    if (newContentObject.type === CompanyNewsTileType.Template) {
      return true
    }

    if (!newContentObject.imageUrl) {
      this.setState({imageError: this.props.formatMessage({id: "platform.homepage.companyNews.editContent.imageRequired"})})
      return false
    }

    return true
  }

  getType = (): CompanyNewsTileType => {
    const {currentTab, companyNewsTile} = this.props

    if (currentTab === SelectedTab.EDIT) {
      return companyNewsTile.config.type
    }

    if (currentTab === SelectedTab.VIDEO) {
      return CompanyNewsTileType.Video
    }

    if (currentTab === SelectedTab.TEMPLATE) {
      return CompanyNewsTileType.Template
    }

    return CompanyNewsTileType.Image
  }

  updateStateContent = (c: CompanyNewsTileConfig) => this.setState({updatedContent: c})
  showPreview = (showPreview: boolean) => this.props.setPreview(showPreview)

  render() {
    const {companyNewsTile, isPreview, onClose} = this.props
    const {imageError, updatedContent} = this.state

    const newContentObject = Object.assign({}, updatedContent, {
      type: this.getType()
    })

    return (
      <Form
        onSubmit={() => {
          const isValid = this.validateHasImage(newContentObject)
          if (isValid) {
            this.updateTile(newContentObject, companyNewsTile, onClose)
          }
        }}>
        <ModalContent>
          {isPreview && <Preview companyNewsTileConfig={newContentObject} />}

          {!isPreview && newContentObject.type === CompanyNewsTileType.Image && (
            <NewImage
              companyNewsTileConfig={newContentObject}
              imageError={imageError}
              removeImageError={() => this.setState({imageError: undefined})}
              updateContent={this.updateStateContent} />
          )}
          {!isPreview && newContentObject.type === CompanyNewsTileType.Video && (
            <NewVideo companyNewsTileConfig={newContentObject} updateContent={this.updateStateContent} />
          )}
          {!isPreview && newContentObject.type === CompanyNewsTileType.Template && (
            <NewTemplateTile companyNewsTileConfig={newContentObject} updateContent={this.updateStateContent} />
          )}
        </ModalContent>
        <ContentFooter
          isPreviewView={isPreview}
          showPreview={this.showPreview}
          onSubmit={() => {
            const isValid = this.validateHasImage(newContentObject)
            if (isValid) {
              this.updateTile(newContentObject, companyNewsTile, onClose)
            }
          }} />
      </Form>
    )
  }
}
export default injectIntl(withAuth(CompanyNewsContentForm))
